import React, { PureComponent } from 'react'
import { isIE, isEdge } from 'globals/constants'
import styles from './styles.scss'

class BGAnimationContainer extends PureComponent {
  render() {
    // IE doesn't do SVG stroke animation properly, this class is appended and makes the css rules invalid
    const ieFixClass = isIE || isEdge ? '-isIE' : ''

    const layer1 = (
      <g className={`${styles.layer1}${ieFixClass}`}>
        <rect
          className={`${styles.layer1RootNode}${ieFixClass}`}
          x="1195"
          y="63"
          width="26"
          height="26"
          rx="4"
          strokeWidth="2"
          stroke="#ED193A"
        />
        <g className={`${styles.layer1Group}${ieFixClass}`} transform="translate(1219.000000, 1.000000)" opacity="0.5">
          <rect stroke="#ED193A" strokeWidth="2" x="101" y="13" width="26" height="26" rx="4" />
          <rect stroke="#F8E71C" strokeWidth="2" x="58" y="1" width="26" height="26" rx="4" />
          <rect stroke="#518DD6" strokeWidth="2" x="41" y="39" width="26" height="26" rx="4" />
          <rect stroke="#ED193A" strokeWidth="2" x="1" y="25" width="26" height="26" rx="4" />
        </g>
        <path
          className={`${styles.layer1Path}${ieFixClass}`}
          d="M1194,76 L1032,76 L1032,76 C1025.37258,76 1020,81.372583 1020,88 L1020,372"
          stroke="#ED193A"
          strokeWidth="2"
        />
      </g>
    )

    const layer2 = (
      <g className={`${styles.layer2}${ieFixClass}`}>
        <rect
          className={`${styles.layer2RootNode}${ieFixClass}`}
          fill="#ED193A"
          x="1006"
          y="372"
          width="28"
          height="28"
          rx="4"
        />
        <g className={`${styles.layer2Group}${ieFixClass}`} transform="translate(966.000000, 406.000000)" opacity="0.5">
          <rect stroke="#ED193A" strokeWidth="2" x="81" y="51" width="26" height="26" rx="4" />
          <rect stroke="#F8E71C" strokeWidth="2" x="40" y="1" width="26" height="26" rx="4" />
          <rect stroke="#518DD6" strokeWidth="2" x="81" y="12" width="26" height="26" rx="4" />
          <rect stroke="#ED193A" strokeWidth="2" x="1" y="1" width="26" height="26" rx="4" />
        </g>
        <path
          className={`${styles.layer2Path}${ieFixClass}`}
          d="M1006,386 L425,386 L425,386 C418.372583,386 413,391.372583 413,398 L413,608"
          stroke="#ED193A"
          strokeWidth="2"
        />
      </g>
    )

    const layer3 = (
      <g className={`${styles.layer3}${ieFixClass}`}>
        <g className={`${styles.layer3RootNode}${ieFixClass}`} transform="translate(399.000000, 594.000000)">
          <rect
            className={`${styles.layer3RootNodeBorderStart}${ieFixClass}`}
            stroke="#518DD6"
            strokeWidth="2"
            x="1"
            y="1"
            width="26"
            height="26"
            rx="4"
          />
          <rect className={`${styles.layer3RootNodeFill}${ieFixClass}`} fill="#ED193A" x="6" y="6" width="16" height="16" rx="2" />
          <rect
            className={`${styles.layer3RootNodeBorderEnd}${ieFixClass}`}
            stroke="#518DD6"
            strokeWidth="2"
            x="-332"
            y="1"
            width="26"
            height="26"
            rx="4"
          />
        </g>
        <path
          className={`${styles.layer3Path}${ieFixClass}`}
          d="M399,608 L94,608"
          stroke="#518DD6"
          strokeWidth="2"
          strokeLinecap="square"
        />
      </g>
    )

    const layer4 = (
      <g className={`${styles.layer4}${ieFixClass}`}>
        <rect
          className={`${styles.layer4RootNodeStart}${ieFixClass}`}
          fill="#ED193A"
          x="65"
          y="325"
          width="28"
          height="28"
          rx="4"
        />
        <path
          className={`${styles.layer4PathStart}${ieFixClass}`}
          d="M94,341 L258,341 L258,341 C264.627417,341 270,346.372583 270,353 L270,934"
          stroke="#F8E71C"
          strokeWidth="2"
        />
        <rect
          className={`${styles.layer4RootNodeEnd}${ieFixClass}`}
          fill="#ED193A"
          x="256"
          y="934"
          width="28"
          height="28"
          rx="4"
        />
        <g className={`${styles.layer4Group}${ieFixClass}`} transform="translate(170.000000, 895.000000)" opacity="0.5">
          <rect stroke="#ED193A" strokeWidth="2" x="1" y="81" width="26" height="26" rx="4" />
          <rect stroke="#F8E71C" strokeWidth="2" x="52" y="40" width="26" height="26" rx="4" />
          <rect stroke="#518DD6" strokeWidth="2" x="38" y="81" width="26" height="26" rx="4" />
          <rect stroke="#ED193A" strokeWidth="2" x="52" y="1" width="26" height="26" rx="4" />
        </g>
        <path
          className={`${styles.layer4PathFinish}${ieFixClass}`}
          d="M284,948 L568,948 L568,948 C574.627417,948 580,953.372583 580,960 L580,1123"
          stroke="#F8E71C"
          strokeWidth="2"
        />
      </g>
    )

    const layer5 = (
      <g className={`${styles.layer5}${ieFixClass}`}>
        <rect
          className={`${styles.layer5RootNode}${ieFixClass}`}
          fill="#ED193A"
          x="566"
          y="1123"
          width="28"
          height="28"
          rx="4"
        />
        <g
          className={`${styles.layer5Group}${ieFixClass}`}
          transform="translate(587.000000, 1148.000000)"
          opacity="0.5"
        >
          <rect stroke="#ED193A" strokeWidth="2" x="27" y="101" width="26" height="26" rx="4" />
          <rect stroke="#F8E71C" strokeWidth="2" x="39" y="58" width="26" height="26" rx="4" />
          <rect stroke="#518DD6" strokeWidth="2" x="1" y="41" width="26" height="26" rx="4" />
          <rect stroke="#ED193A" strokeWidth="2" x="14" y="1" width="26" height="26" rx="4" />
        </g>
      </g>
    )

    return (
      <svg
        className={styles.wrapper}
        width="1180px"
        height="1180px"
        viewBox="0 0 1440 1440"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xlinkHref="http://www.w3.org/1999/xlink"
      >
        <title>Kogan Pattern</title>
        <g className="kgn-internet-bg" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          {layer1}
          {layer2}
          {layer3}
          {layer4}
          {layer5}
        </g>
      </svg>
    )
  }
}

export default BGAnimationContainer



// WEBPACK FOOTER //
// ./components/BGAnimation/index.jsx